// File: /Users/alex/PilotMode/GlobalCommand-Center/FrontStack/src/Pages/LandingPage/FeaturesSection.js

import React from "react";
import { Typography, Box, Grid, Container, Paper, Chip } from "@mui/material";
import { features } from './data';

const FeaturesSection = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 10 }}>
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Chip
          label="FEATURES"
          sx={{
            mb: 2,
            background: "#ede9fe",
            color: "#7c3aed",
            fontWeight: 700,
            fontSize: "12px",
            letterSpacing: "1px",
          }}
        />
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: "#1f2937",
            mb: 2,
            fontSize: { xs: "2rem", md: "2.5rem" },
          }}
        >
          Everything you need to
          <br />
          <Box component="span" sx={{ color: "#667eea" }}>
            manage your team
          </Box>
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#6b7280",
            maxWidth: 600,
            mx: "auto",
            fontSize: "18px",
          }}
        >
          Powerful features designed to help teams collaborate better and achieve more.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                height: "100%",
                borderRadius: "20px",
                border: "1px solid #e5e7eb",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 16px 48px rgba(0,0,0,0.08)",
                  borderColor: feature.color,
                },
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "16px",
                  background: `${feature.color}15`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 3,
                }}
              >
                {React.cloneElement(feature.icon, { sx: { color: feature.color } })}
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: "#1f2937",
                  mb: 1.5,
                }}
              >
                {feature.title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#6b7280",
                  lineHeight: 1.7,
                }}
              >
                {feature.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default FeaturesSection;